export default __webpack_public_path__ + "static/media/190629_192557_DSCN3451.59e1d074.JPG";